module.exports = __webpack_public_path__ + "img/back_young_home.85aae51f.png";